import { render, staticRenderFns } from "./qr-scanner.vue?vue&type=template&id=6bd8734b&scoped=true&"
import script from "./qr-scanner.vue?vue&type=script&lang=js&"
export * from "./qr-scanner.vue?vue&type=script&lang=js&"
import style0 from "./qr-scanner.vue?vue&type=style&index=0&id=6bd8734b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8734b",
  null
  
)

export default component.exports